import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

const initialState = {
  isFetching: false,
  data: {},
  videoData: {},
  isLoggedIn: false,
};

export const digitalClassReducer = createReducer(initialState, {
  [types.DIGITAL_CLASS_RESPONSE](state, action) {
    return {
      ...state,
      timestamp: action.response.timestamp,
      data: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.DIGITAL_VIDEO_RESPONSE](state, action) {
    return {
      ...state,
      videoData: action.response.data,
      errorMessage: action.response.message,
      videoUrl: action.response.data.ClassURL
    };
  },
  [types.REDIRECT_CLASS](state, action) {
    return {
      ...state,
      uniqueCode: action.response,
    };
  },
  [types.TIMER](state, action) {
    return {
      ...state,
      timerData: action.response,
    };
  },
  [types.LOG_OUT]() {
    return {
      ...initialState,
    };
  },
});
